// Home.js
import React from 'react';
import PublicHeader from '../components/PublicHeader';
import HomeHeroV2 from '../components/HomeHeroV2';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import HomeMotion from '../components/HomeMotion';

const Home = () => {
  return (
    <div>
      <SEO
        title="Algorithmic Trading Services"
        description="Bubble Analytics provides trading strategy backtesting, algorithmic trading automation, and trading signals for systematic traders."
        path="/"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Bubble Analytics',
          url: 'https://bubble-analytics.com/',
          email: 'info@bubble-analytics.com',
          description: 'Trading strategy backtesting, algorithmic trading automation, and trading signals for systematic traders.',
        }}
      />
      <PublicHeader />
      <HomeMotion>
        <div data-home-motion-section data-home-accent="green">
          <HomeHeroV2 />
        </div>
      </HomeMotion>
      <Footer />
    </div>
  ); 
};

export default Home; 
